import type { NlAovqlStaticFilesId } from '../model.ts'

export const nlAovql_V1_0_0_StaticFilesIds = [
  'nl-aovql-v1_0_0-general-terms-nl',
  'nl-aovql-v1_0_0-general-terms-en',
  'nl-aovql-v1_0_0-ipid',
] as const satisfies readonly NlAovqlStaticFilesId[]
